import React from "react";
import './newsModal.css'

export default function NewsModal ({news,onClose}){
    if(!news) return null;
    return(
        <div className="news-modal-backdrop"  onClick={onClose}>
            <div className="news-modal-content" onClick={e=> e.stopPropagation()}>
                <button className="news-modal-close" onClick={onClose}>X</button>
                <h2>{news.title}</h2>
                <p>{new Date(news.date).toLocaleDateString()}</p>
                <p>{news.content}</p>
                <img src={news.image} alt={news.title}/>
                <p>{news.content}</p>                
            </div>
        </div>
    )

}